// Mutations
export const SET_CLIENTES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientes.data = payload
    state.clientes.lastUpdate = new Date()
  }
}
export const ADD_CLIENTES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.clientes.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientes.data.push(data)
      }
    })
  }
}
export const SET_CLIENTES_LOADING = (state, payload) => {
  state.clientes.loading = payload
}

export const SET_CONFIG = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.config.data = payload
    state.config.lastUpdate = new Date()
  }
}
export const ADD_CONFIG = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.config.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.config.data.push(data)
      }
    })
  }
}
export const SET_CONFIG_LOADING = (state, payload) => {
  state.config.loading = payload
}

export const SET_SIGNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.signers.data = payload
    state.signers.lastUpdate = new Date()
  }
}
export const ADD_SIGNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.signers.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.signers.data.push(data)
      }
    })
  }
}
export const SET_SIGNERS_LOADING = (state, payload) => {
  state.signers.loading = payload
}

export const SET_IPS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.ips.data = payload
    state.ips.lastUpdate = new Date()
  }
}
export const SET_IPS_QUESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.ipsQuestions.data = payload
  }
}
export const ADD_IPS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.ips.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.ips.data.push(data)
      }
    })
  }
}
export const SET_IPS_LOADING = (state, payload) => {
  state.ips.loading = payload
}

export const SET_FORMS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.forms.data = payload
    state.forms.lastUpdate = new Date()
  }
}
export const ADD_FORMS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.forms.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.forms.data.push(data)
      }
    })
  }
}
export const SET_FORMS_LOADING = (state, payload) => {
  state.forms.loading = payload
}

export const SET_FORMS_ANSWER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.formsAnswer.data = payload
    state.formsAnswer.lastUpdate = new Date()
  }
}
export const ADD_FORMS_ANSWER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.formsAnswer.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.formsAnswer.data.push(data)
      }
    })
  }
}
export const SET_FORMS_ANSWER_LOADING = (state, payload) => {
  state.formsAnswer.loading = payload
}

export const SET_QUESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.questions.data = payload
    state.questions.lastUpdate = new Date()
  }
}
export const ADD_QUESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.questions.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.questions.data.push(data)
      }
    })
  }
}
export const SET_QUESTIONS_LOADING = (state, payload) => {
  state.questions.loading = payload
}

export const SET_FORM_CLIENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.formClient.data = payload
    state.formClient.lastUpdate = new Date()
  }
}
export const ADD_FORM_CLIENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.formClient.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.formClient.data.push(data)
      }
    })
  }
}
export const SET_FORM_CLIENT_LOADING = (state, payload) => {
  state.formClient.loading = payload
}
export const SET_KIT_DOCUMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.kitDocumentos.data = payload
    state.kitDocumentos.lastUpdate = new Date()
  }
}
export const ADD_KIT_DOCUMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.kitDocumentos.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.kitDocumentos.data.push(data)
      }
    })
  }
}
export const SET_KIT_DOCUMENTOS_LOADING = (state, payload) => {
  state.kitDocumentos.loading = payload
}

export const SET_DATA_APP_CLIENTE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.dataAppCliente.data = payload
    state.dataAppCliente.lastUpdate = new Date()
  }
}
export const ADD_DATA_APP_CLIENTE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.dataAppCliente.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.dataAppCliente.data.push(data)
      }
    })
  }
}
export const SET_DATA_APP_CLIENTE_LOADING = (state, payload) => {
  state.dataAppCliente.loading = payload
}

export const SET_KYC_CLASSIFICATION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.kycClassification.data = payload
    state.kycClassification.lastUpdate = new Date()
  }
}
export const SET_KYC_CLASSIFICATION_LOADING = (state, payload) => {
  state.kycClassification.loading = payload
}

export const SET_PENDENCIAS_IPS_KYC = (state, payload) => {
  state.pendenciasIpsKyc.data = payload
  state.pendenciasIpsKyc.lastUpdate = new Date()
  state.pendenciasIpsKyc.loading = false
}

export const SET_PENDENCIAS_IPS_KYC_LOADING = (state, payload) => {
  state.pendenciasIpsKyc.loading = payload
}
